import { Hashtag } from './Hashtag';
import './News.css';
import { Alert, CircularProgress } from '@mui/material';
import { useNews } from '../api/newsApi';


export default function News() {
    const { data: databaseNews = [], isLoading, error } = useNews();

    return (
        <section className="news-container">
            <header className="news-header">
                <h2><Hashtag text="#News" /></h2>
            </header>

            {isLoading && <CircularProgress size={24} aria-label="News werden geladen" />}
            {error && <Alert severity="error">Datenbank-News konnten nicht geladen werden.</Alert>}
            <div className="news-grid">
                {databaseNews.map(item => (
                    <article className="news-card" key={item.id}>
                        {item.image ? (
                            <img
                                className="news-image"
                                src={item.image}
                                alt={item.title}
                                onClick={item.link ? () => window.open(item.link, '_blank', 'noopener,noreferrer') : undefined}
                            />
                        ) : (
                            <div className="news-image placeholder">
                                <span>{item.placeholder}</span>
                            </div>
                        )}

                        <div className="news-body">
                            <h3 className="news-title">{item.title}</h3>
                            <time className="news-date">
                                {item.date?.includes('-')
                                    ? new Date(`${item.date}T00:00:00`).toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' })
                                    : item.date}
                            </time>
                            <p className="news-desc">{item.excerpt}</p>
                            {(item.link || item.pdf) && (
                                <a
                                    className="news-cta"
                                    href={item.pdf || item.link}
                                    target={item.pdf ? undefined : '_blank'}
                                    rel={item.pdf ? undefined : 'noreferrer'}
                                >
                                    {item.pdf ? 'PDF herunterladen ↓' : 'Mehr erfahren →'}
                                </a>
                            )}
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}